import installationInstructions from './installationInstructions';

const cameraCategoryContent = {
  installationInstructions
}

export { cameraCategoryContent };
